// extracted by mini-css-extract-plugin
module.exports = {"membership":"AddTeamMember_membership__39KYN","saveBtn":"AddTeamMember_saveBtn__uoxau","hideParentModal":"AddTeamMember_hideParentModal__1DT9H"};